import ReactGA from "react-ga";

if (typeof window !== "undefined" && process.env.NEXT_PUBLIC_REACT_APP_GA !=="") {
  ReactGA.initialize(process.env.NEXT_PUBLIC_REACT_APP_GA);
  ReactGA.plugin.require("ecommerce");
}
export default ReactGA;
